import {
  useCreatePollMutation,
  useEditPollMutation,
  useGetPollsQuery
} from '@bo-services/pollsApi';
import { useCallback } from 'react';

export const usePolls = (page: number, date?: string) => {
  const {
    isError,
    data,
    isLoading,
    error,
    refetch: refetchPolls
  } = useGetPollsQuery({
    page,
    date
  });

  const { polls, totalCount, totalPages } = data ?? {
    polls: [],
    totalCount: 0,
    totalPages: 0
  };

  const [
    createPoll,
    {
      isLoading: isCreatingPoll,
      error: createPollError,
      isSuccess: createPollSuccess
    }
  ] = useCreatePollMutation();

  const [
    editPoll,
    {
      isLoading: isEditingPoll,
      error: editPollError,
      isSuccess: editPollSuccess
    }
  ] = useEditPollMutation();

  const handleCreatePoll = useCallback(
    (formData: FormData) => {
      createPoll(formData)
        .then(() => refetchPolls())
        .catch(() => undefined);
    },
    [createPoll, refetchPolls]
  );

  const handleEditPoll = useCallback(
    (formData: FormData, pollId: string) => {
      editPoll({ formData, pollId })
        .then(() => refetchPolls())
        .catch(() => undefined);
    },
    [editPoll, refetchPolls]
  );

  return {
    error,
    isError,
    isLoading,
    isEditingPoll,
    isCreatingPoll,
    createPollError,
    editPollError,
    editPollSuccess,
    createPollSuccess,
    handleCreatePoll,
    handleEditPoll,
    polls,
    totalCount,
    totalPages,
    refetchPolls
  };
};
